export default __webpack_public_path__ + "static/media/profile.daa46626.png";